import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { UsersRepository } from "@/api/users/repository";
import { UsersService } from "@/api/users/service";
import type { IInviteDetailsResponse } from "@/api/users/types";
import { ROUTES } from "@/router";
import { serverErrorHandler } from "@/utils/serverErrorHandler";

const Register = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    const usersRepository = new UsersRepository(new UsersService(), {
      abort: true,
    });
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");
    const tenant = params.get("tenant");

    if (!token) {
      return;
    }

    usersRepository
      .getInviteDetailsByToken({
        token,
      })
      .then((response: IInviteDetailsResponse) => {
        const { user, token: inviteToken, alreadyRegistered } = response;
        let qs = `email=${encodeURIComponent(user.email)}&fullName=${encodeURIComponent(user.fullName)}&id=${encodeURIComponent(user.id)}&token=${encodeURIComponent(inviteToken)}&alreadyRegistered=${alreadyRegistered}`;

        if (tenant) {
          qs += `&tenant=${encodeURIComponent(tenant)}`;
        }

        if (alreadyRegistered) {
          navigate(`/${ROUTES.AUTH}/${ROUTES.SIGN_IN}?${qs}`);
        } else {
          navigate(`/${ROUTES.AUTH}/${ROUTES.SIGN_UP}?${qs}`);
        }
      })
      .catch(
        serverErrorHandler(() => {
          navigate(`/${ROUTES.AUTH}/${ROUTES.SIGN_IN}`);
        }),
      );
  }, [t, navigate]);

  return null;
};

export default Register;
